'use strict';

var _ = require('lodash');
var PooledSeasonalityInputDataFilterModalController = function PooledSeasonalityInputDataFilterModalController($scope) {
  $scope.filters = _.clone($scope.defaultFilters);
  $scope.isButtonDisabled = true;
  $scope.resetFilters = function () {
    $scope.filters = _.clone($scope.defaultFilters);
    $scope.isButtonDisabled = true;
  };
  $scope.submitFilters = function () {
    $scope.$emit('pooled-seasonality:apply-input-filters', $scope.filters);
  };
  $scope.closeFilterModal = function () {
    $scope.$emit('pooled-seasonality:filter-toggle');
  };
  $scope.checkButtonStatus = function () {
    if ($scope.isButtonDisabled) {
      $scope.isButtonDisabled = false;
    }
  };
};
PooledSeasonalityInputDataFilterModalController.$inject = ['$scope'];
module.exports = PooledSeasonalityInputDataFilterModalController;